import React, { useState, forwardRef, useCallback, useEffect } from 'react';
import Grid from '@mui/joy/Grid';
import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import Box from '@mui/joy/Box';
import Switch, { switchClasses } from '@mui/joy/Switch';


/////////////////////Date Piker
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dateFormat, { masks } from "dateformat";


/////////////////// Modal
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import Stack from '@mui/joy/Stack';
import Add from '@mui/icons-material/Add';
import Textarea from '@mui/joy/Textarea';
import SvgIcon from '@mui/joy/SvgIcon';
import { styled } from '@mui/joy';
import ModalClose from '@mui/joy/ModalClose';

//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


import AddIconImage from '../../assets/icons/Add-icon.svg'



/////////////// Components
import ListDescount from '../../Components/Descount/ListDescount';



//////////////////////// API
import { createNewCoupons, getAllCoupons } from '../../Api/Coupons';



const schema = yup.object({
    code: yup.string().required("هذا الحقل مطلوب"),
    discount: yup.string().required("هذا الحقل مطلوب"),
    num_of_use: yup.string().required("هذا الحقل مطلوب"),
    expire_at: yup.string().required("هذا الحقل مطلوب"),

})



const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;
const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function DescountPage() {
    const [checked, setChecked] = useState(false);
    const [coupons, setCoupons] = useState([]);
    
    const [openModal, setOpenModal] = useState(false)
    const [open, setOpen] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            code: null,
            discount: null,
            percent: 0,
            num_of_use: null,
            expire_at: null
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };

    const submitExpireDate = (data) => {
        // let formatDate = data.year() + '-' + (data.month() + 1) + '-' + data.day()
        let formatDate = dateFormat(data, 'd-m-yyyy')

        setValue('expire_at', formatDate)
        // console.log(formatDate)
    }

    const submitNewCode = async (data) => {
        if(data.percent) {
            data.percent = 1
        }else{
            data.percent = 0
        }
        // console.log(data)
        const res = await createNewCoupons(data);
        if(res){
            getCoupons();
            setMessageAlert('تم اضافة كود الخصم بنجاح')
            setOpenAlert(true)
            setOpen(false)
            setValue('code', null)
            setValue('discount', null)
            setValue('expire_at', null)
            setValue('num_of_use', null)
            setValue('percent', 0)
            setChecked(0)
        }
    }

    const getCoupons = useCallback(async () => {
        const res = await getAllCoupons();
        if (res) {
            setCoupons(res)
        }
    }, []);

    useEffect(() => {
        getCoupons();
    }, [getCoupons])

    return (
        <>
            {/* Alert Meesage */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>


            {/* Modal Create New */}
            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={open}
                onClose={() => setOpen(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflowY: 'scroll', paddingTop: '0', direction: 'rtl' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{
                        Width: 500,
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                        position: 'relative',
                    }}
                >
                    <DialogTitle sx={{ fontSize: '20px', color: '#434448', fontWeight: 'bold' }}>إضافة كود جديد</DialogTitle>
                    {/* <ModalClose variant="plain" sx={{ m: 1, position: 'absolute', left: '0' }} /> */}
                    <Box sx={{ width: '500px', paddingTop: '30px' }}>
                        <form
                            onSubmit={handleSubmit(submitNewCode)}
                        >
                            <Stack spacing={4}>
                                <FormControl>
                                    <FormLabel>اسم الكود</FormLabel>
                                    <Input
                                        sx={{ height: '60px', borderRadius: '30px' }}
                                        type='text'
                                        placeholder='ادخل اسم الكود هنا.....'
                                        {...register('code')}
                                    />
                                    {errors.code &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.code?.message}</Typography>
                                    }
                                </FormControl>

                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', paddingLeft: '20px' }}>
                                        <FormLabel>{checked ? 'نسبة الخصم' : 'قيمة للخصم'}</FormLabel>
                                        <Switch
                                            variant={checked ? 'solid' : 'outlined'}
                                            checked={checked}
                                            onChange={(event) => {setChecked(event.target.checked); setValue('percent', event.target.checked)}}
                                            sx={(theme) => ({
                                                display: 'inherit',
                                                '--Switch-trackWidth': '40px',
                                                '--Switch-trackHeight': '20px',
                                                '--Switch-thumbSize': '12px',
                                                '--Switch-thumbBackground': '#E8F5E9',
                                                '--Switch-trackBorderColor': '#3E64F4',
                                                '--Switch-trackBackground': theme.vars.palette.background.body,
                                                '&:hover': {
                                                    '--Switch-trackBorderColor': 'rgb(50, 49, 48)',
                                                    '--Switch-trackBackground': theme.vars.palette.background.body,
                                                },
                                                [`&.${switchClasses.checked}`]: {
                                                    '--Switch-trackBackground': '#3E64F4',
                                                    '&:hover': {
                                                        '--Switch-trackBackground': '#3E64F4',
                                                    },
                                                },
                                                [`&.${switchClasses.disabled}`]: {
                                                    '--Switch-thumbColor': '#C8C6C4',
                                                    '--Switch-trackBorderColor': '#C8C6C4',
                                                },
                                                [`&.${switchClasses.disabled}.${switchClasses.checked}`]: {
                                                    '--Switch-trackBackground': '#C8C6C4',
                                                    '--Switch-thumbColor': '#F3F2F1',
                                                },
                                                [theme.getColorSchemeSelector('dark')]: {
                                                    '--Switch-trackBorderColor': 'rgb(161, 159, 157)',
                                                    '--Switch-trackBackground': 'rgb(27, 26, 25)',
                                                    '--Switch-thumbBackground': 'rgb(161, 159, 157)',
                                                    '&:hover': {
                                                        '--Switch-trackBorderColor': '#fff',
                                                        '--Switch-thumbBackground': '#fff',
                                                    },
                                                    [`&.${switchClasses.checked}`]: {
                                                        '--Switch-trackBackground': 'rgb(40, 153, 245)',
                                                        '--Switch-thumbBackground': 'rgb(27, 26, 25)',
                                                        '&:hover': {
                                                            '--Switch-trackBackground': 'rgb(108, 184, 246)',
                                                        },
                                                    },
                                                },
                                            })}
                                        />
                                    </Box>
                                    <Input
                                        sx={{ height: '60px', borderRadius: '30px' }}
                                        placeholder={checked ? ' نسبة الخصم.....' : 'قيمة للخصم .....'}
                                        type='number'
                                        {...register('discount')}
                                    />
                                    {errors.discount &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.discount?.message}</Typography>
                                    }
                                </FormControl>

                                <FormControl>
                                    <FormLabel>عدد مرات استخدام الكود</FormLabel>
                                    <Input
                                        sx={{ height: '60px', borderRadius: '30px' }}
                                        type='number'
                                        placeholder='عدد استخدام الكود.....'
                                        {...register('num_of_use')}
                                    />
                                    {errors.num_of_use &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.num_of_use?.message}</Typography>
                                    }
                                </FormControl>

                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <FormControl>
                                        <FormLabel>تاريخ انتهاء الكود</FormLabel>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker onChange={submitExpireDate} format='YYYY-MM-DD' />
                                        </LocalizationProvider>
                                        {errors.expire_at &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.expire_at?.message}</Typography>
                                    }
                                    </FormControl>
                                </Box>

                                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end', paddingTop: '40px' }}>
                                    <Button type="submit" sx={{ borderRadius: '15px', backgroundColor: '#3E64F4', height: '60px', width: '170px', marginLeft: '20px' }}>اضافة الكود</Button>
                                    <Button type="button" onClick={() => setOpen(false)} sx={{ borderRadius: '15px', backgroundColor: '#757778', height: '60px', width: '170px' }}>الغاء</Button>
                                </Box>
                            </Stack>
                        </form>
                    </Box>
                </Sheet>
            </Modal>

            <Box sx={{ backgroundColor: '#F7F9FB', padding: '50px 3%' }}>
                <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                    sx={{ width: '100%' }}
                >
                    <Grid xs={6}>
                        <Typography level="h2" fontSize="xl" sx={{ mb: 0.5 }}>
                            أكواد الخصومات
                        </Typography>
                    </Grid>
                    <Grid xs={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={() => setOpen(true)} startDecorator={<img src={AddIconImage} className='imgIconButton' alt='icon add' />}>إضافة كود جديد</Button>
                    </Grid>
                </Grid>
                <ListDescount coupons={coupons} getCoupons={getCoupons}/>
            </Box>
        </>
    )
}
